import { BsCalendar2Date } from "react-icons/bs";
import Aos from "aos";
import "aos/dist/aos.css";
import Resume from "../../assets/resume/Arbia.pdf";
import "./about.scss";

const About = ({ menu }) => {
  Aos.init({ duration: 1000 });
  return (
    <section className={`about ${menu && "open"}`}>
      <div className="container">
        <div className="row">
          <div className="section-title padd-15">
            <h2>About Me</h2>
          </div>
        </div>
        <div className="row">
          <div className="about-content padd-15">
            <div className="row">
              <div className="about-text">
                <h3 data-aos="fade-in">
                  I'm Nadir Arbia, a <span>Full-Stack / blockchain Developer</span>
                </h3>
                <p data-aos="fade-in">
                  Senior Full Stack and Blockchain Developer with over 10 years
                  of experience in building robust, scalable, and secure web and
                  blockchain applications. Proficient in MERN, MEAN, Laravel,
                  and Python, with a strong understanding of front-end and
                  back-end technologies. Skilled in Solidity and Rust for smart
                  contract development and experienced in integrating blockchain
                  solutions into web applications. Proven ability to lead and
                  collaborate with cross-functional teams to deliver complex
                  projects on time and within budget. Passionate about exploring
                  new technologies and continuously improving skills to drive
                  innovation and create value for clients and stakeholders.
                </p>
              </div>
            </div>
            <div className="row" data-aos="fade-in">
              <div className="personal-info padd-15">
                <div className="row">
                  <div className="info-item padd-15" data-aos="fade-in">
                    <p>
                      Alias : <span>Nadir</span>
                    </p>
                  </div>
                  <div className="info-item padd-15" data-aos="fade-in">
                    <p>
                      GitHub : <span>https://github.com/software711</span>
                    </p>
                  </div>
                  <div className="info-item padd-15" data-aos="fade-in">
                    <p>
                      Email : <span>dan38003@gmail.com</span>
                    </p>
                  </div>
                  <div className="info-item padd-15" data-aos="fade-in">
                    <p>
                      Degree : <span>Master in Computer Engineering</span>
                    </p>
                  </div>
                  <div className="info-item padd-15" data-aos="fade-in">
                    <p>
                      Certifications : <span>Full Stack && Blockchain Developer</span>
                    </p>
                  </div>
                </div>
                {/* <div className="row" data-aos="fade-in">
                  <div className="buttons">
                    <a
                      href={Resume}
                      download
                      className="btn"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Get Resume
                    </a>
                  </div>
                </div> */}
              </div>
              <div className="skills padd-15">
                <div className="row">
                  <div className="skill-item" data-aos="fade-in">
                    <h3>ReactJS / NextJS/ Angular / Vue js</h3>
                    <div className="progress">
                      <div className="progress-in" style={{ width: "95%" }} />
                      <div className="skill-percent">95%</div>
                    </div>
                  </div>
                  <div className="skill-item" data-aos="fade-in">
                    <h3>Asp.net / Ruby</h3>
                    <div className="progress">
                      <div className="progress-in" style={{ width: "90%" }} />
                      <div className="skill-percent">90%</div>
                    </div>
                  </div>
                  <div className="skill-item" data-aos="fade-in">
                    <h3>NodeJS / ExpressJS / Django / Laravel</h3>
                    <div className="progress">
                      <div className="progress-in" style={{ width: "90%" }} />
                      <div className="skill-percent">90%</div>
                    </div>
                  </div>
                  <div className="skill-item" data-aos="fade-in">
                    <h3>Web3.js / Ethers.js</h3>
                    <div className="progress">
                      <div className="progress-in" style={{ width: "80%" }} />
                      <div className="skill-percent">80%</div>
                    </div>
                  </div>
                  <div className="skill-item" data-aos="fade-in">
                    <h3>Tailwind / MaterialUI</h3>
                    <div className="progress">
                      <div className="progress-in" style={{ width: "95%" }} />
                      <div className="skill-percent">95%</div>
                    </div>
                  </div>
                  <div className="skill-item" data-aos="fade-in">
                    <h3>Solidity / Go</h3>
                    <div className="progress">
                      <div className="progress-in" style={{ width: "95%" }} />
                      <div className="skill-percent">95%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="education padd-15" data-aos="fade-in">
                <h3 className="title">Experience</h3>
                <div className="row">
                  <div className="timeline-box">
                    <div className="timeline shadow-dark">
                      <div className="timeline-item">
                        <div className="circle-dot" />
                        <h3 className="timeline-date">
                          <BsCalendar2Date className="fa fa-calendar" />
                          <i>Jun 2023 - Mar 2026</i>
                        </h3>
                        <h4 className="timeline-title">
                          FULL STACK DEVELOPER (full time) @ Chatkick,
                          Atlanta Geogria US
                        </h4>
                        <p className="timeline-text">
                          -Developed and maintained web applications using React and
                          NextJS,Vue,Angular, optimizing for seamless user experiences and high
                          performance.
                        </p>
                        <p className="timeline-text">
                          -Develop and maintain backend systems using Go,Django,Nodejs.
                        </p><p className="timeline-text">
                          -Collaborated with AI specialists to integrate machine learning models
                          using AWS Lambda and OpenAI, enhancing application functionalities.
                        </p><p className="timeline-text">
                          -Improved the system architecture, enhancing security and scaling
                          capabilities effectively using serverless technologies.
                        </p><p className="timeline-text">
                          -Led front-end development, ensuring cross-browser compatibility and
                          responsiveness for diverse user needs.
                        </p><p className="timeline-text">
                          -Utilized AWS services, such as AWS Lambda, for efficient serverless
                          computing to integrate and deploy machine learning models.
                        </p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot" />
                        <h3 className="timeline-date">
                          <BsCalendar2Date className="fa fa-calendar" />
                          <i>APR 2018 - MAY 2023</i>
                        </h3>
                        <h4 className="timeline-title">
                          BLOCKCHAIN DEVELOPER @ CommScope, New
                          York, US
                        </h4>
                        <p className="timeline-text">
                          -Specialized in developing, integrating and deploying smart contracts on
                          Ethereum/Solana Network using
                          Hardhat/Truffle/Remix.
                        </p>
                        <p className="timeline-text">
                          -Expertise in building NFT Marketplace, NFT games, NFT Foundry Website,
                          NFT Art Image by rarity, OpenSea, Pinata, Metadata Generate, Staking,
                          Reveal Function
                        </p> <p className="timeline-text">
                          -Proficient in ERC-20, ERC-721, ERC-1155, Solidity, Rust
                        </p> <p className="timeline-text">
                          -Utilized AWS services, such as AWS Lambda, for efficient serverless
                          computing to integrate and deploy machine learning models.
                        </p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot" />
                        <h3 className="timeline-date">
                          <BsCalendar2Date className="fa fa-calendar" />
                          <i>OCT 2014 - FEB 2018</i>
                        </h3>
                        <h4 className="timeline-title">
                          FULL STACK DEVELOPER @ Remote Leaf, Atlanta Geogria US
                        </h4>
                        <p className="timeline-text">
                          -Introduced and implemented front-end frameworks, leading the
                          transition to more dynamic React-based application platfrom.
                        </p>
                        <p className="timeline-text">
                          -Assisted in the design and deployment of serverless APIs with NextJS on
                          Vercel, allowing efficient data management and user interaction.
                        </p> <p className="timeline-text">
                          -Developed back-end components using Postgres and Kotlin, ensuring robust
                          data integrity and performance
                        </p> <p className="timeline-text">
                          -Managed cloud platforms and CI/CD pipelines, improving deployment
                          efficiency and reliability by 30%.
                        </p> <p className="timeline-text">
                          -Fostered innovation through collaboration with cross-functional teams to
                          enhance AI components for predictive analytics and decision support.
                        </p>
                      </div>
                    </div>
                    ß
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
